import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'

import Button from '../../../components/button'
import Modal from '../../../components/modal'
import ModalHeader from '../../../components/modalHeader'
import ModalBody from '../../../components/modalBody'
import FormGroup from '../../../components/formGroup'
import FormLabel from '../../../components/formLabel'
import FormInput from '../../../components/formInput'

import { creditLimit } from '../../actions'

const CreditLimitEnquiryModal = ({
  auctionUuid,
  onClose
}) => {
  const dispatch = useDispatch()
  const userId = useSelector((state) => state.users?.user?.id)
  const auctionId = useSelector((state) => state.auctions.auctions?.[auctionUuid]?.id)
  const [isAwaitingResponse, setAwaitingResponse] = useState(false)
  const [newLimitValue, setNewLimitValue] = useState('')
  const [messageValue, setMessageValue] = useState('')
  const isMounted = useRef(true)

  useEffect(() => {
    isMounted.current = true

    return () => {
      isMounted.current = false
    }
  }, [])

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      setAwaitingResponse(true)
      const request = await dispatch(creditLimit.enquiry({
        userId,
        auctionId,
        amount: newLimitValue,
        message: messageValue
      }))

      if (!isMounted.current) return

      switch (request.type) {
        case 'CREDIT_ENQUIRY_SUCCESS':
          toast.success('Credit Limit request sent successfully')
          break
        default:
          toast.error('Error: Unable to send request')
      }
      setNewLimitValue('')
      setMessageValue('')
    } catch (err) {
      console.error(err)
      if (isMounted.current) {
        toast.error('Error: Unable to send request')
      }
    } finally {
      if (isMounted.current) {
        setAwaitingResponse(false)
        onClose()
      }
    }
  }

  return (
    <Modal onClose={onClose} isOpen id='creditLimitEnquiryModal' size='sm'>
      <ModalHeader onClose={onClose} id='credit-limit-enquiry__header'>
        <h2>Credit Limit Enquiry</h2>
      </ModalHeader>
      <ModalBody>
        <form
          className='credit-limit__enquiry-form'
          onSubmit={handleSubmit}
        >
          <FormGroup>
            <FormLabel for='new-limit'>New Limit</FormLabel>
            <FormInput
              id='new-limit'
              type='text'
              name='new-limit'
              required
              pattern='[0-9]*'
              placeholder='eg. 50000'
              value={newLimitValue}
              onChange={(e) => setNewLimitValue(e.target.value)}
              onInvalid={(e) => e.target.setCustomValidity('Please only use numbers.')}
              onInput={(e) => e.target.setCustomValidity('')}
            />
          </FormGroup>
          <FormGroup>
            <FormLabel for='message'>Message</FormLabel>
            <FormInput
              id='message'
              type='textarea'
              name='message'
              value={messageValue}
              onChange={(e) => setMessageValue(e.target.value)}
            />
          </FormGroup>
          <div className='auction-modal-buttons'>
            <Button
              id='credit-limit-cancel'
              onClick={onClose}
              className='btn-primary-outline btn-block credit-limit__cta'
            >
              Cancel
            </Button>
            <Button
              disabled={isAwaitingResponse}
              id='credit-limit-submit'
              type='submit'
              color='primary'
              className='btn-block credit-limit__cta'
            >
              Submit
            </Button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  )
}

CreditLimitEnquiryModal.propTypes = {
  auctionUuid: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
}

export default CreditLimitEnquiryModal
